import {
  API_ENDPOINT,
  useClientApiV1AccountsNotificationQuery,
} from '../../resources/@types/accountSchema';

function useClientAccountNotificationQuery(
  options?: Parameters<typeof useClientApiV1AccountsNotificationQuery>[0]['options'],
) {
  return useClientApiV1AccountsNotificationQuery({
    queryKey: [API_ENDPOINT.CLIENT_V1_ACCOUNTS_NOTIFICATION],
    url: API_ENDPOINT.CLIENT_V1_ACCOUNTS_NOTIFICATION,
    options,
  });
}

useClientAccountNotificationQuery.queryKey = [API_ENDPOINT.CLIENT_V1_ACCOUNTS_NOTIFICATION];

export default useClientAccountNotificationQuery;
